export default {
  INLINE: 'inline',
  TOP: 'top',
  BOTTOM: 'bottom'
};
